export enum WorldpayTransactionSource {
  Genio = 'G',
  Orbit = 'O',
  ProductReplacement = 'R',
  RepairAndCareCancellation = 'D',
  Scheme = 'S',
  Web = 'W',
}
